"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Popper_1 = __importDefault(require("@mui/material/Popper"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const arrowStyle = {
    position: 'absolute',
    fontSize: 7,
    width: '3em',
    height: '3em',
    '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        right: 8,
        width: 10,
        height: 10,
        backgroundColor: 'inherit',
        transform: 'translateY(-50%) rotate(45deg)',
        boxShadow: '-3px -3px 5px -2px rgba(0,0,0,0.1)',
    },
};
function DetailPopup({ children, placement, anchorEl, settings = {} }) {
    // const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [open, setOpen] = React.useState(false);
    // const [placement, setPlacement] = React.useState<PopperPlacementType>();
    const [arrowRef, setArrowRef] = React.useState(null);
    React.useEffect(() => {
        setOpen(!!anchorEl);
    }, [anchorEl]);
    return (anchorEl && ((0, jsx_runtime_1.jsx)(Popper_1.default, Object.assign({ sx: { zIndex: 2, width: '100%', minWidth: '30vw', maxWidth: '50vw', minHeight: '40vh', maxHeight: '80vh' }, open: open, anchorEl: anchorEl, placement: placement, transition: true, modifiers: [
            {
                name: 'arrow',
                enabled: true,
                options: {
                    element: arrowRef,
                },
            },
        ] }, { children: ({ TransitionProps }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.default, { component: 'span', sx: arrowStyle, ref: setArrowRef }), (0, jsx_runtime_1.jsx)(Fade_1.default, Object.assign({}, TransitionProps, { timeout: 350 }, { children: (0, jsx_runtime_1.jsx)(Paper_1.default, Object.assign({ sx: Object.assign({ height: '100%', padding: 2 }, settings) }, { children: children })) }))] })) }))));
}
exports.default = DetailPopup;
